import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FatalErrorService } from './fatal-error.service';

@Injectable({ providedIn: 'root' })
export class ToastNotificationService {
  constructor(
    private readonly messageService: MessageService,
    private readonly fatalErrorService: FatalErrorService
  ) {}

  showError(detail: string): void {
    if (this.fatalErrorService.active) {
      return;
    }
    this.messageService.add({ severity: 'error', summary: 'Error', detail, life: 5000 });
  }

  showSuccess(detail: string): void {
    if (this.fatalErrorService.active) {
      return;
    }
    this.messageService.add({ severity: 'success', summary: 'Success', detail, life: 3000 });
  }

  showWarn(detail: string): void {
    if (this.fatalErrorService.active) {
      return;
    }
    this.messageService.add({ severity: 'warn', summary: 'Warning', detail, life: 5000 });
  }
}
